// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ChatPage from './pages/ChatPage';
//import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import OAuthCallback from './pages/OAuthCallback';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './ThemeContext';
import LoginWrapper from './pages/LoginWrapper';
import Dashboard from './components/Dashboard';


// Component to log every route change
const RouteLogger = () => {
  const location = useLocation();
  useEffect(() => {
    console.log("Navigated to:", location.pathname + location.search);
  }, [location]);
  return null;
};

// const PrivateRoute = ({ children }) => {
//   const { user } = useAuth();
  
//   if (!user) {
//     return <Navigate to="/login" />;
//   }
//   return children;
// };

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          {/* This will log every navigation change */}
          <RouteLogger />
          <Routes>
            <Route path="/login" element={<LoginWrapper />} />
            <Route path="/signup" element={<LoginWrapper />} />
            <Route path="/google-callback" element={<OAuthCallback />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/" element={<Navigate to="/chat" />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
